import { render, staticRenderFns } from "./eventflow.vue?vue&type=template&id=3b20e0ed&scoped=true&"
import script from "./eventflow.vue?vue&type=script&lang=js&"
export * from "./eventflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20e0ed",
  null
  
)

export default component.exports